import { createReducer, on } from '@ngrx/store';
import * as GlobalActions from './global.actions';

export interface GlobalState {
  language: string;
  theme: string;
}

export const initialState: GlobalState = {
  language: 'en',
  theme: 'light'
};

export const globalReducer = createReducer(
  initialState,
  on(GlobalActions.setLanguage, (state, { language }) => ({ ...state, language })),
  on(GlobalActions.setTheme, (state, { theme }) => ({ ...state, theme }))
);
